import * as React from 'react';
import { LineChart } from '@mui/x-charts/LineChart';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from '../../theme/create-theme';

interface LineChartWrapperProps {
  height: number;
  series: any[];
  xAxis: any[];
  yAxis: any[];
  sx?: any;
  margin?: any;
}

export function LineChartWrapper({
  height,
  series,
  xAxis,
  yAxis,
  sx,
  margin
}: LineChartWrapperProps) {
  return (
    <ThemeProvider theme={theme}>
      <LineChart
        height={height}
        series={series}
        xAxis={xAxis}
        yAxis={yAxis}
        sx={sx}
        margin={margin}
      />
    </ThemeProvider>
  );
} 